import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MxBrowserStorageService, MxStorageType } from './mx.browser-storage.service';

/**
 * Az új Szirom-váz állapota: összecsukott oldalmenü (72 px ikonsáv), mobil fiók, globális kereső,
 * értesítés-számláló. A képernyők a kereső eseményére és a számlálóra iratkozhatnak fel.
 */
@Injectable({ providedIn: 'root' })
export class SzShellService {
  private static readonly COLLAPSED_KEY = 'sz-sidebar-collapsed';

  readonly collapsed$ = new BehaviorSubject<boolean>(!!MxBrowserStorageService.get(MxStorageType.Local, SzShellService.COLLAPSED_KEY));
  readonly drawerOpen$ = new BehaviorSubject<boolean>(false);
  readonly badge$ = new BehaviorSubject<number>(0);
  readonly search$ = new Subject<string>();

  get collapsed(): boolean {
    return this.collapsed$.value;
  }

  toggleCollapse() {
    const next = !this.collapsed$.value;
    MxBrowserStorageService.set(MxStorageType.Local, SzShellService.COLLAPSED_KEY, next);
    this.collapsed$.next(next);
  }

  openDrawer() {
    this.drawerOpen$.next(true);
  }

  closeDrawer() {
    this.drawerOpen$.next(false);
  }

  setBadge(count: number) {
    this.badge$.next(Math.max(0, count || 0));
  }

  search(term: string) {
    this.search$.next((term || '').trim());
  }
}
